import { styled } from 'stitches.config'

export const PostTableOfContentsRoot = styled('div', {
  backgroundColor: '$accent-white',
  borderRadius: '8px',
  border: '1px solid $secondary-500',
  padding: '12px 18px',

  '@bp2': {
    padding: '24px 36px',
  },
})

export const TableOfContentsHeading = styled('h4', {
  fontSize: '$h5',
  lineHeight: '$h5',
  letterSpacing: '$h5',
  fontFamily: '$display',
  fontWeight: '$semiBold',
  color: '$accent-black',
  marginTop: 0,
  marginBottom: '$2',
})

export const TableOfContentsList = styled('ol', {
  margin: 0,
  paddingLeft: '$3',
  listStyleType: 'decimal',

  '& li': {
    marginBottom: '$1',

    '&:last-child': {
      marginBottom: 0,
    },
  },

  '@bp2': {
    paddingLeft: '$3',
  },
})

export const TableOfContentsLink = styled('a', {
  fontSize: '$body',
  lineHeight: '$body',
  fontFamily: '$primary',
  color: '$accent-black',
  textDecoration: 'none',
  transition: 'color 0.2s ease',

  '&:hover': {
    color: '$primary-500',
    textDecoration: 'underline',
  },

  '&:focus': {
    outline: '2px solid $primary-500',
    outlineOffset: '2px',
  },
})
